export enum UnlockModalState {
    UnlockInfo,
    ContactUs,
}

export interface IUnlockModalState {
    page: number;
    current: UnlockModalState;
    currentSlide: IUnlockModalSlide | null;
    submitted: boolean;
}

export interface IUnlockModalSlide {
    img?: string;
    img2x?: string;
    trackId?: string;
    // Optional width of img element. Default is 420px.
    imgWidth?: number;

    // TODO: Make optional (for no image case)
    title: string;

    subtitle: string;
    text: string;
}

export type UnlockModalSlides<T extends string> = {
    [name in T]: IUnlockModalSlide;
};

export interface IUnlockModalProps {
    isOpen: boolean;
    onCloseClick?: () => void;
    onAfterOpen?: () => void;
    location: string;
    activeSlide?: string;
    slides: UnlockModalSlides<string>;
    ctaText: string;
    label: string;
    onCtaClickTrack?: () => void;
}
